import * as _ from 'underscore'
import { IReferenceType } from '../../models/util/interfaces'
import { OpDevice, OpDepositoryElement, OpPackage, OpArticle } from '../../models/core'

import { ColumnModel } from '../../modules/api/api.models'

import { LocalizationHelper, Dictionary } from '../../helpers'

import { GRID_SERVICE_NAME, GridService } from '../grid'

import { Enums } from '../../models/common'

import { PACKAGE_SERVICE_NAME, PackageService } from './package.service'
import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../user-session'
import { size } from 'underscore'

//#region Public Types

export const PACKAGE_CONTENT_SERVICE_NAME = 'PackageContentService'
export const PACKAGE_CONTENT_SERVICE_PROVIDER_NAME = 'PackageContentServiceProvider'

//#endregion

export class PackageContentService {


    //#region Consts

    public static get LOG_PREFIX(): string { return '[SIMAX.Services.Package.Content]' }

    //#endregion


    //#region Ctor

    constructor(
        private gridService: GridService,
        private packageService: PackageService,
        private userSessionService: UserSessionService
    ) { }

    //#endregion


    //#region Columns

    public getEditIconInCell(options: any, dataField: string): void {
        this.gridService.getEditIconInCell(options, dataField)
    }

    public getConfirmGridColumns(): ColumnModel[] {
        const columns: ColumnModel[] = this.getPackageContentColumns(true)
        const checkBoxColumn: ColumnModel = new ColumnModel()

        checkBoxColumn.idName = 'accepted'
        checkBoxColumn.name = 'accepted'
        checkBoxColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm)
        checkBoxColumn.type = Enums.DataTypeClass.Boolean
        checkBoxColumn.allowEditing = true

        columns.push(checkBoxColumn)

        columns.reverse()

        return columns
    }

    public getPackageContentColumns(isContentEditable: boolean = false): ColumnModel[] {
        const articleColumn: ColumnModel = new ColumnModel()

        articleColumn.idName = 'article'
        articleColumn.name = 'article'
        articleColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Article)
        articleColumn.type = Enums.DataTypeClass.Text

        const serialNbrColumn: ColumnModel = new ColumnModel()

        serialNbrColumn.idName = 'externalSn'
        serialNbrColumn.name = 'externalSn'
        serialNbrColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SerialNbr)
        serialNbrColumn.type = Enums.DataTypeClass.Text

        const notesColumn: ColumnModel = new ColumnModel()

        notesColumn.idName = 'notes'
        notesColumn.name = 'notes'
        notesColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Notes)
        notesColumn.type = Enums.DataTypeClass.Text
        notesColumn.allowEditing = isContentEditable

        return [articleColumn, serialNbrColumn, notesColumn]
    }

    public getDeviceColumns(): JQueryPromise<ColumnModel[]> {
        return this.gridService.getPopupColumnModelByReferenceType(Enums.ReferenceType.SerialNbr)
    }

    //#endregion

    // #region Grid Edit

    public opDepositoryElementToOpDevice(contentList: OpDepositoryElement[]): OpDevice[] {
        return contentList.map((depoElement: OpDepositoryElement) => {

            const newDevice: OpDevice = new OpDevice(null)

            newDevice.serialNbr = depoElement.serialNbr
            newDevice.opState = depoElement.opState

            return newDevice
        })
    }

    public onPackageContentSubmit(added: OpDepositoryElement[], removed: OpDepositoryElement[], inGrid: OpDepositoryElement[], currentDepositories: OpDepositoryElement[], pack: OpPackage): JQueryPromise<OpPackage> {

        const notRemovedDepositoryElements: OpDepositoryElement[] = _.size(pack.contentList) > 0 ? pack.contentList.filter((depElem: OpDepositoryElement) => {
            return !removed.some((remDepElem: OpDepositoryElement) => {
                return remDepElem.idDepositoryElement === depElem.idDepositoryElement
            })
        }) : []

        const depositoriesToAdd: OpDepositoryElement[] = []
        const depositoriesToClose: OpDepositoryElement[] = []

        if (_.size(notRemovedDepositoryElements) > 0) {
            notRemovedDepositoryElements.forEach((depElem: OpDepositoryElement) => {
                const depositoryToChange: OpDepositoryElement = inGrid.find((de: OpDepositoryElement) => de.idDepositoryElement === depElem.idDepositoryElement && de.externalSn !== depElem.externalSn)
                if (depositoryToChange != null) {
                    const toClose: OpDepositoryElement = new OpDepositoryElement(null)
                    toClose.copy(depositoryToChange)

                    depositoryToChange.serialNbr = null
                    depositoriesToAdd.push(depositoryToChange)

                    toClose.removed = true
                    toClose.opState = Enums.OpChangeState.Modified
                    toClose.endDate = new Date(Date.now())
                    depositoriesToClose.push(toClose)
                }
            })
        }

        const addedElem: OpDepositoryElement[] = this.getUpdatedAddedDepositoryElements(added, inGrid)

        const newDepoElements: OpDepositoryElement[] = addedElem.concat(depositoriesToAdd).map((depoElement: OpDepositoryElement) => {
            const depositoryElement: OpDepositoryElement = new OpDepositoryElement(null)
            const depoElementClone = depoElement.clone(true, true, true, true)
            depositoryElement.idArticle = depoElement.idArticle != null ? depoElement.idArticle : 0
            depositoryElement.startDate = new Date(Date.now())
            depositoryElement.opState = Enums.OpChangeState.New
            depositoryElement.idDepositoryElement = 0
            depositoryElement.idDeviceStateType = Enums.DeviceStateType.IDLE
            depositoryElement.idDeviceTypeClass = Enums.DeviceTypeClass.RADIO_DEVICE
            depositoryElement.serialNbr = depoElementClone.serialNbr
            depositoryElement.externalSn = depoElementClone.externalSn
            depositoryElement.notes = depoElementClone.notes
            depositoryElement.accepted = depoElementClone.accepted
            depositoryElement.idReference = depoElementClone.idReference
            depositoryElement.ordered = depoElementClone.ordered

            return depositoryElement
        })

        const removedDepoElements: OpDepositoryElement[] = removed.map((depoElem: OpDepositoryElement) => {
            const currentDepoElement: OpDepositoryElement = _.find(currentDepositories, (e: OpDepositoryElement) => e.idDepositoryElement == depoElem.getReferenceKey())
            const depositoryElement: OpDepositoryElement = new OpDepositoryElement(null)

            depositoryElement.idArticle = currentDepoElement.idArticle
            depositoryElement.startDate = currentDepoElement.startDate
            depositoryElement.endDate = new Date(Date.now())
            depositoryElement.opState = Enums.OpChangeState.Modified
            depositoryElement.idDepositoryElement = currentDepoElement.idDepositoryElement
            depositoryElement.idDeviceStateType = Enums.DeviceStateType.IDLE
            depositoryElement.idDeviceTypeClass = Enums.DeviceTypeClass.RADIO_DEVICE
            depositoryElement.serialNbr = depoElem.serialNbr
            depositoryElement.externalSn = depoElem.externalSn
            depositoryElement.notes = depoElem.notes
            depositoryElement.accepted = depoElem.accepted
            depositoryElement.idReference = depoElem.idReference
            depositoryElement.removed = true
            depositoryElement.ordered = depoElem.ordered

            return depositoryElement
        })

        const removedDepoElementIds: number[] = removedDepoElements.map((depoElements: OpDepositoryElement) => depoElements.idDepositoryElement)
        removedDepoElementIds.push(...depositoriesToClose.map((depoElements: OpDepositoryElement) => depoElements.idDepositoryElement))
        const loadedDepoElements: OpDepositoryElement[] = currentDepositories
            .filter((loadedDepoElem: OpDepositoryElement) => removedDepoElementIds.indexOf(loadedDepoElem.idDepositoryElement) === -1)
            .map((elem: OpDepositoryElement) => {
                const depositoryElement: OpDepositoryElement = new OpDepositoryElement(null)

                depositoryElement.idArticle = elem.idArticle
                depositoryElement.startDate = new Date(Date.now())
                depositoryElement.opState = Enums.OpChangeState.Modified
                depositoryElement.idDepositoryElement = elem.idDepositoryElement
                depositoryElement.idDeviceStateType = Enums.DeviceStateType.IDLE
                depositoryElement.idDeviceTypeClass = Enums.DeviceTypeClass.RADIO_DEVICE
                depositoryElement.serialNbr = elem.serialNbr
                depositoryElement.externalSn = elem.externalSn
                depositoryElement.notes = elem.notes
                depositoryElement.accepted = elem.accepted
                depositoryElement.idReference = elem.idReference
                depositoryElement.ordered = elem.ordered

                return depositoryElement
            })

        const objectToSave: OpPackage = pack.clone(true, true, true, true)

        objectToSave.opState = Enums.OpChangeState.Modified
        objectToSave.contentList = [...depositoriesToClose, ...loadedDepoElements, ...newDepoElements, ...removedDepoElements]

        return this.packageService
            .savePackage(objectToSave)
            .then((pack: OpPackage) => {
                return this.getArticlesFromDictionary(pack)
            })
    }

    private getArticlesFromDictionary(pack: OpPackage): JQueryPromise<OpPackage> {

        return this.userSessionService
            .getDataProvider()
            .System
            .getDictionaries([Enums.ReferenceType.IdArticle])
            .then((dict: Dictionary<Dictionary<IReferenceType>>) => {
                const articleDictionary: Dictionary<IReferenceType> = dict.tryGetValue(Enums.ReferenceType.IdArticle)
                if (pack != null && _.size(pack.contentList) > 0) {
                    pack.contentList.forEach((depoElement: OpDepositoryElement) => {
                        if (depoElement.article == null) {
                            depoElement.article = articleDictionary.tryGetValue(depoElement.idArticle) as OpArticle
                        }
                    })
                }

                return pack
            })
    }

    public getSourceObject(device: any): IReferenceType {
        return this.gridService.getSourceObjectFromGridObject(device, Enums.ReferenceType.SerialNbr)
    }

    public confirmPackage(pckage: OpPackage): JQueryPromise<OpPackage> {
        return this.packageService.savePackage(pckage)
    }

    private getUpdatedAddedDepositoryElements(added: OpDepositoryElement[], inGrid: OpDepositoryElement[]): OpDepositoryElement[] {
        const addedIds: number[] = _.map(added, (element: OpDepositoryElement) => element.idDepositoryElement)
        return inGrid.filter((elem: OpDepositoryElement) => _.some(addedIds, (id: number) => id == elem.idDepositoryElement)) || []
    }

    // #endregion 
}


export class PackageContentServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [GRID_SERVICE_NAME, PACKAGE_SERVICE_NAME, USER_SESSION_SERVICE_NAME, function (
        gridService: GridService,
        packageService: PackageService,
        userSessionService: UserSessionService
    ) {
        return new PackageContentService(gridService, packageService, userSessionService);
    }]

    //#endregion
} 